import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const PreImportChecklistContainer = styled.div`
  padding: 24px;
  margin: auto;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const Title = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH3)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const PreImportInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledChecklistContainer = styled.div`
  display: flex;
  border-color: ${(props) =>
    props.theme.atlas.semantic.color.ui.divider.default};
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.subtle};
  padding: 16px;
  border: 1px solid;
  border-radius: 4px;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
`;

export const ChecklistSectionContainer = styled.div`
  display: flex;
  gap: 16px;
`;

export const ChecklistSectionTitle = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  font-weight: 600;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ChecklistDescription = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  margin-left: 40px;

  a {
    ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
    font-weight: 600;

    &:hover {
      ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
      font-weight: 600;
    }
  }
`;

export const ChecklistSectionDetails = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const StyledText = styled.span`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  text-align: center;
`;

export const CtaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
`;
